module.exports = __webpack_public_path__ + "static/woocommerce_paypal-12b72a6f7433e1022eaba78c50c29cc3.svg";